var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiCopilotMagicFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.48 1.87L16.5 0l1.02 1.87c.37.68.93 1.24 1.61 1.61L21 4.5l-1.87 1.02c-.68.37-1.24.93-1.61 1.61L16.5 9l-1.02-1.87c-.37-.68-.93-1.24-1.61-1.61L12 4.5l1.87-1.02c.68-.37 1.24-.93 1.61-1.61zm0 15L16.5 15l1.02 1.87c.37.68.93 1.24 1.61 1.61L21 19.5l-1.87 1.02c-.68.37-1.24.93-1.61 1.61L16.5 24l-1.02-1.87c-.37-.68-.93-1.24-1.61-1.61L12 19.5l1.87-1.02c.68-.37 1.24-.93 1.61-1.61zM9 6L7.64 8.49c-.49.9-1.23 1.64-2.14 2.14l-2.49 1.36 2.49 1.36c.9.49 1.64 1.23 2.14 2.14L9 17.98l1.36-2.49c.49-.9 1.23-1.64 2.14-2.14l2.49-1.36-2.49-1.36c-.9-.49-1.64-1.23-2.14-2.14L9 6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiCopilotMagicFill);
export default __webpack_public_path__ + "7e25b0703bc25480551214815a6c8747.svg";
export { ForwardRef as ReactComponent };